import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverviewInfoComponent } from './overview-info/overview-info.component';
import { TravelAgendaInfoComponent } from './travel-agenda-info/travel-agenda-info.component';
import { RecommendedDiseaseInfoComponent } from './recommended-disease-info/recommended-disease-info.component';
import { RecommendedPrescriptionInfoComponent } from './recommended-prescription-info/recommended-prescription-info.component';
import { RecommendedLabTestInfoComponent } from './recommended-lab-test-info/recommended-lab-test-info.component';
import { RecommendedAuditTrailInfoComponent } from './recommended-audit-trail-info/recommended-audit-trail-info.component';
import { AttachmentInfoComponent } from './attachment-info/attachment-info.component';
import { MomentModule } from 'angular2-moment';
import { SharedModule } from '../../../../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MomentModule
  ],
  declarations: [
    OverviewInfoComponent,
    TravelAgendaInfoComponent,
    RecommendedDiseaseInfoComponent,
    RecommendedPrescriptionInfoComponent,
    RecommendedLabTestInfoComponent,
    RecommendedAuditTrailInfoComponent,
    AttachmentInfoComponent
  ],
  exports: [
    OverviewInfoComponent,
    TravelAgendaInfoComponent,
    RecommendedDiseaseInfoComponent,
    RecommendedPrescriptionInfoComponent,
    RecommendedLabTestInfoComponent,
    RecommendedAuditTrailInfoComponent,
    AttachmentInfoComponent
  ]
})
export class GroupTemplateInformationModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/group-template-information.module.ts